import { render, staticRenderFns } from "./doughnutView.vue?vue&type=template&id=037537c2&scoped=true"
import script from "./doughnutView.vue?vue&type=script&lang=js"
export * from "./doughnutView.vue?vue&type=script&lang=js"
import style0 from "./doughnutView.vue?vue&type=style&index=0&id=037537c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037537c2",
  null
  
)

export default component.exports